import { Anchor, Box, Button, Heading, Paragraph } from '@zillow/constellation-10';
import HeroImageZsg from '@assets/pay-rent-online-zillow.png';

interface HeroSectionProps {
  enableContinueToOnboarding: boolean;
  goToSignInPage?: () => void;
  authenticated: boolean;
  onClick: () => void;
}

const HeroSection = ({ onClick, enableContinueToOnboarding, goToSignInPage, authenticated }: HeroSectionProps) => {
  const renderSignUpButton = () => {
    let buttonText = 'Learn how to sign up';
    if (enableContinueToOnboarding) {
      buttonText = 'Continue setup';
    } else {
      buttonText = 'See how to sign up';
    }
    return (
      <Button emphasis="filled" size="lg" onClick={onClick} css={{ marginTop: 'default' }}>
        {buttonText}
      </Button>
    );
  };

  const renderButtonContext = () => {
    let body;
    if (!authenticated) {
      body = (
        <>
          Already using payments?&nbsp;
          <Anchor css={{ textDecoration: 'none' }} onClick={goToSignInPage}>
            Sign in
          </Anchor>
        </>
      );
    } else if (enableContinueToOnboarding) {
      body = "You're nearly ready to pay rent online.";
    } else {
      body = "We'll help you message your landlord.";
    }
    return <Paragraph textStyle="body-sm">{body}</Paragraph>;
  };

  return (
    <Box css={{ position: 'relative', height: '600px', padding: '0', textAlign: 'center' }}>
      <div className="Payments-LandingPage-HeroSection-TextContainer">
        <Box
          css={{
            position: 'relative',
            zIndex: 5,
            textAlign: 'left',
            maxWidth: { base: '400px', sm: '450px', lg: '550px' },
            height: '600px',
            padding: {
              base: '60px 20px',
              sm: '90px 35px',
              lg: '120px 35px',
              xl: '120px 55px',
            },
          }}
        >
          <Heading level={1} textStyle="heading-md" css={{ marginBottom: 'default' }}>
            Say hello to online rent payments.
          </Heading>
          <Heading level={2} textStyle="heading-xs">
            And goodbye to writing rent checks.
          </Heading>
          {renderSignUpButton()}
          {renderButtonContext()}
        </Box>
      </div>
      <img
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          zIndex: 1,
          height: '600px',
          width: '100%',
          objectFit: 'none',
          objectPosition: '-180px -50px',
        }}
        src={HeroImageZsg as unknown as string}
        alt="Say hello to online rent payments."
      />
    </Box>
  );
};

export default HeroSection;
